import * as React from 'react'

function IconLeaf1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={64}
      height={44}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.32 28.968l48.66-16.557L.106 41S50.438 57.938 63.1 6.226c.011.013-49.497-22.967-61.78 22.742z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf1
